"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapInParagraph = void 0;
const wrapInParagraph = html => {
  const isWrappedInPTag = /^<p>[\S\s]*<\/p>$/;
  if (isWrappedInPTag.test(html)) {
    return html;
  }
  return `<p>${html}</p>`;
};
exports.wrapInParagraph = wrapInParagraph;
//# sourceMappingURL=utils.js.map